<template>
   <div class="note" v-show="open">
		<span class="note_content">{{message}}</span>
		<a href="javascript:;" class="btn_close" @click="message=''"><i class="fa fa-remove"></i></a>
	</div>
</template>

<script>
import web from '../webhelper.js';
export default {
		data:function(){
			return {
				message:'',
			}
		},
		mounted:function(){
			var _this=this;
			web.sync('note',function(res){
				_this.message=res.val() || '';
			})
		},
		computed:{
			open:function(){
				return this.message!=''
			},
		},
    }
</script>

<style>
	.note{
		z-index: 10;
		padding: 8px 0;
		background: #fffbee;
		text-align: center;
	}
	.note_content{
		 margin-right: 10px;
		 font-size: 0.8em;
	}   
</style>



// WEBPACK FOOTER //
// note.vue?b266657a